import { DtoType } from "@core/data/dto/dto-types";
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { PaystubSchema } from './paystub.schema';
import { Moment } from 'moment';

@DtoForceConstructor
export class Paystub {

    public id: string;
    public grossTotal: number;
    public netTotal: number;
    public netPay: number;
    public payday: Moment;
    public payrollId: string;
    public periodStart: Moment;
    public periodEnd: Moment;
    public provider: string;
    public providerId: string;
    public status: string;
    public statusMessage: string;
    public taxTotal: number;

    @DtoImport(PaystubSchema)
    static import(dto: Dto): any {
        return new Paystub(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: PaystubSchema,
        },
    ])
    export(type?: DtoType): any {}
}
